export default {
  name: 'KnNotFound',
};
